import { render, staticRenderFns } from "./CourceModelsForm.vue?vue&type=template&id=1f73eebf"
import script from "./CourceModelsForm.vue?vue&type=script&lang=js"
export * from "./CourceModelsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports